import { Injectable } from '@angular/core';
@Injectable({
    providedIn: 'root',
})
export class AuthService {
    hostname = window.location.hostname;
    projectId = this.hostname === 'localhost' ? 'pineapplelab' : this.getProjectIdFromHostname(this.hostname);
    constructor() {}

    getProjectIdFromHostname(hostname: string): string {
        const parts = hostname.split('.');
        const domain = parts.length > 2 ? parts[1] : parts[0];
        return domain.toLowerCase();
    }
}
